import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import ImageIcon from '@material-ui/icons/Image';
import WorkIcon from '@material-ui/icons/Work';
import BeachAccessIcon from '@material-ui/icons/BeachAccess';

//css
import ProdutoCardCss from './ProdutoCard-css';
const useStyles = ProdutoCardCss();

export default function ProdutoCard(props) {
    const classes = useStyles();

    return (
      <Card className={classes.card}>
        <CardContent>
            <Typography variant="h5" component="h2">
                {props.value.nome}
            </Typography>
            <Typography variant="body2" component="p">
                {props.value.descricao}
            </Typography>
            <br/>
            <Typography className={classes.title} color="textSecondary" gutterBottom>
                Fornecedores
            </Typography>
            <List className={classes.root}>
                <div className={classes.lista}>
                    <ListItem>
                        <ListItemAvatar>
                            <Avatar>
                            <ImageIcon />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary="Photos" secondary="Jan 9, 2014" />
                    </ListItem>
                    <ListItem>
                        <ListItemAvatar>
                            <Avatar>
                            <WorkIcon />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary="Work" secondary="Jan 7, 2014" />
                    </ListItem>
                    <ListItem>
                        <ListItemAvatar>
                            <Avatar>
                            <BeachAccessIcon />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary="Vacation" secondary="July 20, 2014" />
                    </ListItem>
                </div>
            </List>
        </CardContent>
      </Card>
    );
}